(function($) {

	$.fn.msxidialog = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxidialog.defaults, options);

		return this.each(function(i) {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;
            if (eOpts["dialog-reset-on-close"]) { eOpts.resetOnClose = true; }

            var $dialog = $('<div></div>');
            $dialog.data('link', $this);
            $dialog.data('eOpts',eOpts);

            initDialog($dialog, eOpts);
        });
	};

	function initDialog($dialog, o) {
		if (o.showLoadingImage) {
			showLoading($dialog, o);
		}

		// In case we are re-initializing dialog, clear previous click listeners that
        // might fire before this before this one (i.e. the click listener attached in
        // loadDialog). This one must be first - that one will be re-attached after this one.
        $dialog.data('link').unbind('click');
        if (o.deferLoad) {
			$dialog.data('link').on('click', function(event) {
                if(!$(this).hasClass('button') || !$(this).button( "option", "disabled" ))
                {
                    loadDialog($dialog, o, true);
                    $(this).off(event); // detach this click handler so control given to click handler configured by loadDialog
                }
				return false;
			});
		} else {
			loadDialog($dialog, o, false);
		}
	}
	function loadDialog($dialog, o, autoOpen) {
        $dialog.addClass('error-handled');
		$.ajax({url: $dialog.data('link').attr('href'),
                success: function(data, textStatus, jqXHR)
                {
                    //If it's redirect request then loading the redirect url to fill the dialog.
                    if (jqXHR.getResponseHeader("Location")) {
                        $.get(jqXHR.getResponseHeader("Location"),
                            function(data, textStatus, XMLHttpRequest) {
                                fillDialog($dialog, data, o, XMLHttpRequest);
                            });
                    } else {
                        fillDialog($dialog, data, o, jqXHR);
                    }
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    errorHandler.call($dialog, $dialog, o, XMLHttpRequest, textStatus, errorThrown);
                }
               });

		$dialog.dialog( $.extend( {
			title : translate(o.loadingTitle),
			autoOpen: autoOpen
			}, o.dialogOptions));

		$dialog.data('link').click(function() {
			$dialog.dialog('open');

			return false;
		});
	}

	function fillDialog($dialog, data, o, jqXHR) {

        var title;
		var body;
		if(o.titleSelector) {
            if(typeof o.titleSelector === 'string')
            {
                title = $(data).find(o.titleSelector).text();
            }
            else
            {
                $.each(o.titleSelector, function(i, titleSelector)
                {
                    title = $(data).find(titleSelector).text();
                    if(title.length > 0) return false;
                });
            }
		}
		else {
			title = $dialog.data('link').attr("title");
		}
		if(o.bodySelector) {
            if(typeof o.bodySelector === 'string')
            {
                body = $(data).find(o.bodySelector);
            }
            else
            {
                $.each(o.bodySelector, function(i, selector)
                {
                    body = $(data).find(selector);
                    if(body.size() > 0) return false;
                });
            }
		}
		else {
			body = $(data);
		}
        if(o.disableLinkSelector) {
            if(typeof o.disableLinkSelector === 'string')
            {
                body.find(o.disableLinkSelector).each(function(index, element){
                    disableLink($(element));
                });
            }
            else
            {
                $.each(o.disableLinkSelector, function(i, selector)
                {
                    body.find(selector).each(function(index, element){
                        disableLink($(element));
                    });
                });
            }
        }

        $dialog.empty().append( body );
		$dialog.dialog( "option" , 'title' , title );
		$dialog.dialog("option", "position", "center");
		$dialog.dialog("option", "resizable", !body.is('.container'));

		if(o.captureDialogForms) {
			initDialogForms($dialog, o);
		}
		if(o.captureDialogLinks) {
			initDialogLinks($dialog, o);
		}
		if(o.resetSelector) {
			initResetSelector($dialog, o);
		}
        if (o.resetOnClose) {
            initResetOnClose($dialog, o);
        }

        o.onDialogLoad.call($dialog, $dialog);
        for(var i = 0; i < $.fn.msxidialog.onDialogLoad.length; i++)
        {
            $.fn.msxidialog.onDialogLoad[i].call($dialog, $dialog);

        }
        o.onDialogLoadPost.call($dialog, $dialog);
	}

    function disableLink($element){
        var linkText = $element.contents();
        $element.replaceWith(linkText);
    }

    function initResetSelector($dialog, o) {
         $dialog.find(o.resetSelector).click(function () {
            $dialog.dialog('close');
             if (!o.resetOnClose) {
                 //Only reset dialog if resetOnClose is false otherwise resetDialog will be called twice
                 resetDialog($dialog, o);
             }
            return false;
        });
	}

	function initResetOnClose($dialog, o) {
        $dialog.dialog("option", "close", function(evt,ui){resetDialog($dialog, o);});
	}

	function resetDialog($dialog, o) {
		$dialog.dialog( "destroy" );
		$dialog.empty();
        if (o.initAfterReset) {
            initDialog($dialog, o);
        }
	}

	function initDialogLinks($dialog, o) {
        // Must support links which are loaded via ajax so use on to attach click handler to handle this scenario.
        // Also must unbind click handlers on entry to prevent nested handlers when user clicks around within paged dialog
        $dialog.unbind('click');
        $dialog.on('click','a:not([target=_top],.ui-tabs-anchor)',function(){
            $dialog.addClass('error-handled');
            var url = $(this).attr('href');
            // ignore href if just a hashtag to element within the dialog
            if (url  && (!(url.indexOf('#') == 0))) {
                $.get(url, function (data, textStatus, jqXHR) {
                        // ResponseHeader will contain location header if invoked link returns a redirect:<view> so
                        // make further ajax call to obtain required screen
                        if ((jqXHR !== undefined) && jqXHR.getResponseHeader("Location")) {
                            $.get(jqXHR.getResponseHeader("Location"),
                                function (data, textStatus, XMLHttpRequest) {
                                    fillDialog($dialog, data, o, XMLHttpRequest);
                                });
                        }
                        else {
                            fillDialog($dialog, data, o, jqXHR);
                        }
                    });
                return false;
            }
        });
    }

	function initDialogForms($dialog, o) {

        $('form', $dialog)
                .not('[enctype=multipart\\/form-data]')
                .not('.disableAjaxSubmit')
                .submit(function() {
                var $enabledSubmits = $dialog.find(".ui-button:submit:enabled").button('disable');
                var $form = $(this);
                // Need to remember if form has been confirmed as this form dataset is cleared by subsequent call to showLoading function
                var confirmedForm = $form.data('confirmed');
                if(!$form.is('.form-confirm-submit') || confirmedForm) {

                    // Create a hidden field to ensure button value is submitted
                    var button = $dialog.data('last-submit-button');
                    if(button && button.attr('name'))
                    {
                        $form.append($('<input type="hidden" />').attr('name', button.attr('name')).val(button.val()));
                        $dialog.removeData('last-submit-button');
                    }
                    $form.find('input.exclude-submit').each(function () {
                        var $this = $(this);
                        if ($this.is(':enabled')) {
                            $this.prop('disabled', true);
                            // A short timeout allows the form to submit and queues the field for re-enablement afterwards
                            setTimeout(function () {
                                $this.prop('disabled', false);
                            }, 1);
                        }
                    });
                    var ajaxSettings = {
                        type: $form.attr("method"),
                        url: $form.attr("action"),
                        data: $form.serialize(),
                        success: function(data, textStatus, XMLHttpRequest)
                        {
                            if(o.handleAjaxSubmitSuccess) {
                                // Received a redirect response
                                if(XMLHttpRequest.getResponseHeader("Location"))
                                {
                                    // If parentDialog exists then this dialog should close and parent dialog should be updated with redirect response
                                    // unless such behaviour has been overriden
                                    if(o.parentDialog && !o.overrideResponseToParentDialog) {
                                        $.get(XMLHttpRequest.getResponseHeader("Location"),
                                            function(data, textStatus, XMLHttpRequest) {
                                                $dialog.dialog('close');
                                                resetDialog($dialog, o);
                                                if ((XMLHttpRequest !== undefined) && XMLHttpRequest.getResponseHeader("Location"))
                                                {
                                                    $.get(XMLHttpRequest.getResponseHeader("Location"),
                                                        function(data, textStatus, XMLHttpRequest) {
                                                            fillDialog(o.parentDialog, data, o.parentDialog.data('eOpts'),XMLHttpRequest);
                                                        });
                                                }
                                                else
                                                {
                                                    fillDialog(o.parentDialog, data, o.parentDialog.data('eOpts'),XMLHttpRequest);
                                                }
                                            });
                                    }
                                    else if(o.locationResponseToDialog) {
                                        $.get(XMLHttpRequest.getResponseHeader("Location"),
                                            function(data, textStatus, XMLHttpRequest) {
                                                if ((XMLHttpRequest !== undefined) && XMLHttpRequest.getResponseHeader("Location"))
                                                {
                                                    $.get(XMLHttpRequest.getResponseHeader("Location"),
                                                        function(data, textStatus, XMLHttpRequest) {
                                                            fillDialog($dialog, data, o, XMLHttpRequest);
                                                        });
                                                }
                                                else
                                                {
                                                    fillDialog($dialog, data, o, XMLHttpRequest);
                                                }
                                            });
                                    }
                                    // Otherwise there is no parent dialog so refresh page with redirect
                                    else {
                                        window.location.href = XMLHttpRequest.getResponseHeader("Location");
                                    }
                                }
                                else
                                {
                                    if(data !== undefined && data != '')
                                    {
                                        fillDialog($dialog, data, o);
                                    }

                                    try {
                                        $enabledSubmits.filter('.ui-button').button('enable');
                                    } catch (e) {
                                        // Using try block because for unknown reason this sometimes fails with:
                                        // "Uncaught Error: cannot call methods on button prior to initialization; attempted to call method 'enable'"
                                    }
                                }
                            }
                            else {
                                $dialog.one('success-handled', function(){
                                    $dialog.dialog('close');
                                    resetDialog($dialog, o);
                                });
                                $dialog.trigger('success', [$dialog, data, textStatus, XMLHttpRequest]);
                            }
                        },
                        error: function(XMLHttpRequest, textStatus, errorThrown) {
                            errorHandler.call($dialog, $dialog, o, XMLHttpRequest, textStatus, errorThrown);
                        }
                    };
                    showLoading($dialog, o);
                    $dialog.addClass('error-handled');
                    $.ajax(ajaxSettings);
                    // showLoading empties the dialog so jquery dataset on form is lost - need to put back confirmed flag (if required) so that
                    // formconfirm dialog does not open again when its submit handler is called
                    if (confirmedForm)
                    {
                        $form.data('confirmed', true);
                    }
                }
                return false;
		});
        // Store the clicked button
        $dialog.find('form button').click(function() {
            $dialog.data('last-submit-button', $(this));
        });
		$("form :reset", $dialog).click(function(){
			$dialog.dialog('close');
			resetDialog($dialog, o);
        });
	}

	function showLoading($dialog, o) {
		if (o.showLoadingImage) {
			var width = $dialog.width()>0 ?  $dialog.width() : 250;
			var height = $dialog.height()>0 ?  $dialog.height() : 150;
            $dialog.empty().append($('<div/>').width(width).height(height).addClass('dialog-loading'));
		}
	}

    function errorHandler($dialog, o, XMLHttpRequest, textStatus, errorThrown)
    {
        if(XMLHttpRequest.responseText !== undefined && XMLHttpRequest.responseText != '')
        {
            fillDialog($dialog, XMLHttpRequest.responseText, o);
            return;
        }

        var msg;
        var title = translate('Connection Error');
        if(XMLHttpRequest.status == 0)
        {
            msg = translate('Unable to load dialog. Please check your connection.');
        }
        else if (XMLHttpRequest.status == 12152)
        {
            msg = translate('Network Error. Please check your connection and try again.');
        }
        else
        {
            title = title + ' : ' + XMLHttpRequest.status;
            msg = translate('Unable to load dialog {0}', [errorThrown]);
        }
        $dialog.dialog("option", 'title', title);
        $dialog.empty().append("<p class='error'>" + msg + "</p>");
    }
    
	//
	// plugin defaults
	//
    $.fn.msxidialog.defaults = {
        deferLoad : true,
        showLoadingImage : true,
        loadingImage : staticImageUrl('/common/loading_bar.gif'),
        loadingTitle : 'loading...',
        titleSelector : ['#main > h2'],
        bodySelector : ['#main .dialog-content', '#main .panel-content:not(.panel-content-message):first > *', '#main > .errorPanel'],
        captureDialogForms: true,
        captureDialogLinks: false,
        overrideResponseToParentDialog: false,
        locationResponseToDialog: false,
        initAfterReset:true,
        disableLinkSelector: [],
        parentDialogDisableLinkSelector: [],
        resetSelector: '.reset-dialog',
        resetOnClose: false,
        parentDialog: null,
        position: 'center',
        handleAjaxSubmitSuccess: true,
        onDialogLoad: function($dialog) {
            // dialog specific callback. Use $.fn.msxidialog.onDialogLoad for generic/global callbacks
        },
        onDialogLoadPost: function($dialog) {
            // dialog specific callback. Use $.fn.msxidialog.onDialogLoad for generic/global callbacks
        },
        dialogOptions: {
            // JQuery officially doesn't support "width: auto" due to it not being possible in IE6.
            // However, it will "just work" in other browsers.
            width : 'auto',
            height : 'auto',
            modal: true
        }
    };
    //
    // onDialogLoad global callback functions.
    // Other plugins can extend this using:
    // $.fn.msxidialog.onDialogLoad.push(someFunction);
    //
    $.fn.msxidialog.onDialogLoad = [function($dialog, o) {
            $dialog.msxiinit();

            // Init any dialog links and confirm-forms with a reference to the parent dialog.
            $dialog.find('a.dialog-link').msxidialog({parentDialog: $dialog});
            $dialog.find('.form-confirm-submit').data('parentDialog', $dialog);
        },
    function($dialog, o) {
        // Focus on the first input field in the dialog
        $dialog.find('.can-focus:first').focus();
    }];

    // This simply exposes the underlying fill function so any client code can call the fillDialog with its own content
    $.fn.msxidialog.customFillDialog = function($dialog, data, o){
            fillDialog($dialog, data, o);
        };

})(jQuery);